import { HeadMetadata } from "@hub/models/metadata/head-metadata";
import { PageConfig } from "@hub/models/ui/page-config";
import { Auth0Header } from "@hub/ui/auth0/auth0-header";
import { PageContainer } from "@hub/ui/layouts/page-container";
import dynamic from "next/dynamic";
import React, { ComponentType } from "react";
import styles from "./shell-layout.module.css";
import { GameBar } from "@hub/ui/challenges/game-bar";
import { MobileGameBar } from "@hub/ui/challenges/mobile-game-bar";
import { RabbitHelperButton } from "@hub/ui/challenges/follow-jwt-rabbit/rabbit-helper-button";

const DynamicAuth0Footer: ComponentType<any> = dynamic(
  () =>
    import("@hub/ui/auth0/auth0-footer").then((mod) => mod.Auth0Footer as any),
  {
    loading: () => <div>Loading...</div>,
  }
);

interface ShellLayoutProps {
  pageConfig: PageConfig;
  header: React.ReactNode;
  headMetadata?: HeadMetadata;
  banner?: React.ReactNode;
  breadcrumbs?: React.ReactNode;
  navigationFolders?: React.ReactNode;
  sidebar?: React.ReactNode;
  document?: React.ReactNode;
  page?: React.ReactNode;
  structuredData?: any;
  compactFooter?: boolean;
}

export const ShellLayout: React.FC<ShellLayoutProps> = ({
  pageConfig,
  headMetadata,
  banner,
  breadcrumbs,
  navigationFolders,
  sidebar,
  document,
  page,
  structuredData,
  header,
  compactFooter = false,
}) => {
  return (
    <PageContainer
      {...pageConfig}
      headMetadata={headMetadata}
      structuredData={structuredData}
    >
      <div className={styles.shell}>
        <div className={styles.shell__header}>
          {header || <Auth0Header />}
          {breadcrumbs}
        </div>
        <main className={styles.shell__main}>
          <div className={styles.shell__mainBody}>
            {page && (
              <>
                <section className={styles.shell__mainContentPage}>
                  {banner}
                  <div className={styles.shell__page}>{page}</div>
                </section>
              </>
            )}
            {document && (
              <>
                {sidebar && (
                  <aside className={styles.shell__mainSidebar}>
                    <>{sidebar}</>
                  </aside>
                )}
                <section
                  className={`${styles.shell__mainContent}${
                    sidebar ? ` ${styles.withSidebar}` : ""
                  }`}
                >
                  {banner}
                  {navigationFolders}
                  <div className={styles.shell__document}>{document}</div>
                </section>
              </>
            )}
          </div>
        </main>
        {<DynamicAuth0Footer compactFooter={compactFooter} />}
        <GameBar />
        <MobileGameBar />
        <RabbitHelperButton />
      </div>
    </PageContainer>
  );
};
